import ElementLocale from "element-ui/lib/locale";
import axios from "axios";

import VueI18n from "vue-i18n";
import Vue from "vue";
import { Notification } from "element-ui";
// import router from "../router";
import langService from "./langService";

Vue.use(VueI18n);

const loadedLanguages = [];
const messages = {};
ElementLocale.i18n(key => i18n.t(key));

const i18n = new VueI18n({
  messages, // set locale messages
  silentTranslationWarn: true
});
function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function getLoadedLanguages() {
  return loadedLanguages;
}

export function getMessages() {
  return messages;
}

export function loadLanguageAsync(lang, langs) {
  i18n.setLocaleMessage(lang, []);

  i18n.setLocaleMessage(lang, langs);
  setI18nLanguage(lang);
}

export default i18n;
